import React, { useEffect } from "react";

declare global {
  interface Window {
    initSendOTP?: (config: any) => void;
    sendOtp?: any;
    verifyOtp?: any;
    retryOtp?: any;
  }
}

const MSG91_SCRIPT_ID = "msg91-script";

interface Msg91ProviderProps {
  widgetId?: string;
  tokenAuth?: string;
}

const Msg91Provider: React.FC<Msg91ProviderProps> = ({
  // Tarun 's id
  // widgetId = "366668665a33353939373232",
  // tokenAuth = "523990T31DaASp6a265f43P1",
  // Chirag's id
  // widgetId = "3666696c6835323338333534",
  // tokenAuth = "524602TKrc7Rpbu6a29478cP1",

   // Sunny's id
  widgetId = "366876637178333136333139",
  tokenAuth = "563138Ta7blSZW6a891a03P1",
}) => {
  useEffect(() => {
    // Prevent multiple script loads
    if (document.getElementById(MSG91_SCRIPT_ID)) return;

    const script = document.createElement("script");
    script.id = MSG91_SCRIPT_ID;
    script.src = "https://verify.msg91.com/otp-provider.js";
    script.async = true;

    script.onload = () => {
      if (!window.initSendOTP) {
        console.error("MSG91 initSendOTP not found");
        return;
      }

      const configuration = {
        widgetId,
        tokenAuth,
        exposeMethods: true,

        success: (data: any) => {
          console.log("MSG91 OTP Verified", data);
        },

        failure: (error: any) => {
          console.log("MSG91 Error", error);
        },
      };

      try {
        window.initSendOTP(configuration);
      } catch (e) {
        console.error("Failed to initialize MSG91 widget", e);
      }

      // debug logs
      // console.debug("initSendOTP:", window.initSendOTP);
      // console.debug("sendOtp:", window.sendOtp);
      // console.debug("verifyOtp:", window.verifyOtp);
      // console.debug("retryOtp:", window.retryOtp);
    };

    script.onerror = () => {
      console.error("Failed to load MSG91 script");
    };

    document.body.appendChild(script);

    // no cleanup to keep the widget available for whole app lifecycle
  }, [widgetId, tokenAuth]);

  return null;
};

export default Msg91Provider;
